import {Component, Injector, Input} from '@angular/core';
import {animate, state, transition, trigger, style} from '@angular/animations';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR, NgControl,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";
import {required} from "@utility";

@Component({
  selector: 'app-multiselect-dropdown',
  templateUrl: './multiselect-dropdown.component.html',
  styleUrls: ['./multiselect-dropdown.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MultiSelectDropdownComponent,
    multi: true
  },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: MultiSelectDropdownComponent
    }],
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class MultiSelectDropdownComponent extends AbstractComponent implements ControlValueAccessor, Validators {
  @Input() options: Map<number | string, string> = new Map<number | string, string>();
  @Input() dropdownLabel: string = "";
  @Input() openDropdownUpwards: boolean = false;

  @Input() maxItemsCount: number | undefined;
  @Input() isButton: boolean = false;
  @Input() buttonIconClass: string | undefined;
  @Input() isTableHeading: boolean = false;
  @Input() required: boolean = false;
  @Input() iconClass: string | undefined;
  @Input() isDropdownListFullWidth: boolean = false;
  /// Disable turning off all items(at least one item should stay selected)
  @Input() isDiabledAllTurnedOff: boolean = false;
  @Input() iconSize: number = 16;

  displayMaxItemsMessage:boolean = false;
  selectedValues?: any
  onChange = (selectedValues: any) => {
  };

  onTouched: () => void = () => {
  };

  touched: boolean = false;
  disabled: boolean = false;
  invalid: boolean = false;
  errors: ValidationErrors | null = null;

  constructor(private inj: Injector) {
    super();
  }

  ngAfterViewInit() {
    const outerControl: AbstractControl | null = this.inj.get(NgControl).control;
    if (outerControl) {
      outerControl.markAsTouched = () => {
        this.touched = true;
      };
      outerControl.markAsUntouched = () => {
        this.touched = false
      };
    }
  }

  writeValue(selectedValues: any) {
    this.selectedValues = selectedValues;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }


  onItemSelect(item: number | string) {
    let selectedOptions = this.selectedValues ? [...this.selectedValues] : [];
    if (this.isDiabledAllTurnedOff && this.selectedValues.length === 1) {
      return;
    }
    let index: number = selectedOptions.indexOf(item, 0);
    if (index > -1) {
      selectedOptions.splice(index, 1);
    } else {
      if (this.maxItemsCount && this.maxItemsCount === selectedOptions.length) {
        this.displayMaxItemsMessage = true;
      } else {
        this.displayMaxItemsMessage = false;
        selectedOptions.push(item);
      }
    }
    this.selectedValues = [...selectedOptions]
    this.onChange(this.selectedValues);
  }

  get formControlValue(): (number | string)[] {
    if (
      this.selectedValues
      && Array.isArray(this.selectedValues)) {
      return [...this.selectedValues]
    } else {
      return [];
    }
  }

  onSelectAll() {
    if (this.isDiabledAllTurnedOff && this.selectedValues.length === this.options.size) {
      return;
    }
    if (this.formControlValue.length === this.options.size) {
      this.selectedValues = []
    } else {
      this.selectedValues = [...this.options.keys()]
    }
    this.onChange(this.selectedValues);
  }

  isOptionSelected(item: number | string): boolean {
    return this.formControlValue.includes(item);
  }

  multiselectDropdownOpenChange(open: boolean) {
    this.markAsTouched();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if ((control.value === undefined || control.value === null || control.value?.length === 0) && (control.hasValidator(required) || this.required)) {
      this.invalid = true;
      this.errors = {
        required: true
      };
      return this.errors;
    } else {
      this.errors = null;
      this.invalid = false;
      return this.errors;
    }
  }
}
